import './footer.css';
export default function Footer(){
    return(
        <footer className="footer">
            <div className="footer__container container">
                <h1 className="footer__title">Muhibul</h1>

                <ul className="footer__list">
                    <li>
                        <a href="#about" className="footer__link">About</a>
                    </li>

                    <li>
                        <a href="#projects" className="footer__link">Projects</a>
                    </li>

                    <li>
                        <a href="#testimonial" className="footer__link">Testimonial</a>
                    </li>

                    <li>
                        <a href="#contact" className="footer__link">Contact</a>
                    </li>
                </ul>

                <div className="footer__social">
                    <a href="https://facebook.com/muhibuwp" className='footer__social-link' target='_blank' rel='noreferrer'>
                        <i className="bx bxl-facebook"></i>
                    </a>

                    <a href="https://github.com/devmuhib009" className='footer__social-link' target='_blank' rel='noreferrer'>
                        <i className="bx bxl-github"></i>
                    </a>

                    <a href="https://profiles.wordpress.org/devmuhib/" className='footer__social-link' target='_blank' rel='noreferrer'>
                        <i className="bx bxl-wordpress"></i>
                    </a>

                    <a href="https://www.youtube.com/@dev-muhib" className='footer__social-link' target='_blank' rel='noreferrer'>
                        <i className="bx bxl-youtube"></i>
                    </a>
                </div>

                <span className="footer__copy">&#169; Muhibul Haque. All rights reserved.</span>
            </div>
        </footer>
    )
}